import { MenuItem } from './menu.model';
var level=  localStorage.getItem('RoleId')
var admin = localStorage.getItem('AdminRole')
export const MENU: MenuItem[] = [

  {
    label: 'User Management',
    isTitle: true,
    
  },
  
  {
    label: 'User',
    icon: 'user-plus',
    link: '/user-management/user'
   
  },
  // {
  //   label: 'Email Templates',
  //   icon: 'user-plus',
  //   link: '/user-management/email'
  // },
  // {
  //   label: 'Role Management',
  //   isTitle: true,
    
  // },

  // {
  //   label: 'Role',
  //   icon: 'user-plus',
  //   link: '/user-management/role'
  // },
 

  {
    label: 'Partner Management',
    isTitle: true,
    
  },
  {
    label: 'Partner',
    icon: 'factory',
    // disable : !(admin?.includes('2')),
   link: '/user-management/partner',
  },
 
  {
    label: 'Plan',
    icon: 'Phone',
    // disable : !(admin?.includes('2')),
   link: '/user-management/plan',
  },
{
    label: 'Surf Plan',
    icon: 'card-sim',
    // disable : !(admin?.includes('2')),
   link: '/user-management/surf-plan',
  },
{
    label: 'Billing Code',
    icon: 'dollar-sign',
    // disable : !(admin?.includes('2')),
   link: '/user-management/billing-code',
  },
{
    label: 'Partner API Key',
    icon: 'key-round',
    // disable : !(admin?.includes('2')),
   link: '/user-management/partner-api-key',
  },
{
    label: 'Activation Footprint',
    icon: 'footprints',
    link: '/inventory/upload-activation-footprint',
   
  },
   {
    label: 'Contacts',
    icon: 'Contact',
    link: '/user-management/partner-contacts',
   
  },
  {
    label: 'Product Restriction',
    icon: 'octagon-x',
    link: '/user-management/product-restriction',
   
  },
{
      label: 'Blocked Products',
  icon: 'route-off',
  link: '/user-management/blocked-products',
},

 
  {
      label: 'Endpoint Restriction',
  icon: 'route-off',
  link: '/user-management/endpoint-restriction',
},
 
{
  label: 'Partner Async',
icon: 'Webhook',
link: '/user-management/partner-async',
},
{
  label: 'Admin',
  isTitle: true,

},
{
    label: 'Add/Update IP by Partner',
    icon: 'user-check',
    link: '/admin/add-update-ip-by-partner'
   
  },


  {
    label: 'Customer',
    isTitle: true,
    
  },
  
  {
    label: 'Subscriber Lookup',
    icon: 'user-check',
    link: '/customer/lookup'
   
  },

  {
    label: 'Activation',
    icon: 'smartphone',
    link: '/customer/activation-request'
   
  },
  {
    label: 'Create Subscriber',
    icon: 'user-plus',
    link: '/customer/create-subscriber',
  },
  {
    label: 'Portin',
    icon: 'shopping-cart',
    subItems: [
      {
        label: 'Validate',
        link: '/customer/portin-eligibility',
      },

      {
        label: 'Create',
        link: '/customer/create-portin',
      },
      
      {
        label: 'Query',
        link: '/customer/query-portin',
      },
      {
        label: 'Update',
        link: '/customer/update-portin',
      },
      {
        label: 'Pending',
        link: '/customer/pending-portin',
      },
       {
        label: 'Change MSISDN',
        link: '/customer/portin-change-msisdn',
      }
    ]
   },
  {
    label: 'Sim Life Cycle Management',
    isTitle: true,
    
  },
  {
    label: 'Create Order',
    icon: 'user-check',
    link: '/inventory/create-sim-order'
   
  },

  {
    label: 'Sim Assignment',
    icon: 'smartphone',
    link: '/inventory/sim-assignment'
   
  },
  {
    label: 'SIM lookup',
    icon: 'smartphone',
    link: '/inventory/single-iccid-lookup'
   
  },

  
  
   
   {

   label: 'Fraud',
   isTitle: true,
   },
   

   {
    label: 'Dashboard',
    icon: 'alert-circle',
    link: '/fraud/fraud-batch-summary',
  },
 
   
  {
      label: 'Upload File',
      icon: 'file-plus',
      link: '/fraud/fraud-file-upload',
  },
    
  {
    label: 'Whitelist User',
    icon: 'user-plus',
    link: '/fraud/whitelist-user',
  },
 {
    label: 'Fraud Types Mapping',
    icon:  'user-plus',
    link: '/fraud/TMO-fraud-types',
  },
  
{
  label: 'Batch Notifications',
  icon: 'list',
  link: '/fraud/Batch-notification',
},



  {
    label: 'Reports',
    isTitle: true,
    
  },
  {
    label: 'API Logs',
    icon: 'list',
    link: '/logs/partner-api-logs'
   
  },

  {
    label: 'Async Logs',
    icon: 'list',
    link: '/logs/partner-async-logs'
   
  },

   {
    label: 'Partner CDR Logs',
    icon: 'list',
    link: '/logs/partner-cdr-logs'
   
  },
  {
    label: 'Carrier  API Logs',
    icon: 'list',
    link: '/logs/carrier-api-logs'
   
  },
  {
    label: 'Carrier Async Logs',
    icon: 'list',
    link: '/logs/carrier-async-logs'
   
  },

  {
    label: 'Carrier CDR Logs',
    icon: 'list',
    link: '/logs/cdr-logs'
  },
  
  {
    label: 'SIP Call Logs',
    icon: 'list',
    link: '/logs/sip-call-logs'
   
  },
  
  {
    label:  'Daily MSISDN changes' ,
    icon: 'list',
    link: '/logs/daily-msisdn-change-logs'
  },

  
 
  {
    label: 'SIP',
    isTitle: true,
    
  },
  {
    label: 'SIP Configuration',
    icon: 'phone-call',
    link: '/sip/sip-Configuration'
   
  },
  




 
  
];

